import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, LayoutGrid, Boxes, MoreHorizontal } from 'lucide-react';
import { Container, cn } from '@easymoving/ui';

/**
 * Desktop navigation (md+). Replaces the mobile bottom-button nav with a
 * horizontal top bar — the floating bottom bar reads as out of place on a
 * wide screen.
 */
export function DesktopNav() {
  const { t } = useTranslation();
  const items = [
    { to: '/app', icon: Home, label: t('nav.dashboard'), end: true },
    { to: '/app/items', icon: LayoutGrid, label: t('nav.items'), end: false },
    { to: '/app/boxes', icon: Boxes, label: t('nav.boxes'), end: false },
    { to: '/app/more', icon: MoreHorizontal, label: t('nav.more'), end: false },
  ];

  return (
    <nav className="print:hidden hidden md:block border-b hairline bg-bg/85 backdrop-blur-md">
      <Container className="flex items-center gap-1 h-14">
        {items.map(({ to, icon: Icon, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'inline-flex items-center gap-2 px-3 py-1.5 rounded-md text-[14px] font-medium transition-colors',
                isActive ? 'bg-petrol-tint text-petrol-deep' : 'text-graphite hover:bg-surface-tint',
              )
            }
          >
            <Icon className="size-4" />
            {label}
          </NavLink>
        ))}
      </Container>
    </nav>
  );
}
